import "./Projects.css";
import ProjectTile from "../components/tiles/projectTile/ProjectTile";

const projects = [
  ["Medtronic Hackathon 2026", { Python: 90.3, "C++": 9.7 }, "https://github.com/silvercube227/mdthack"],
  ["Portfolio Website", { JavaScript: 74.6, CSS: 16.1, HTML: 9.3 }, "https://calebfynewever.com/"],
  ["AprilTag Detection using OpenCV", { Python: 100 }, "https://github.com/caleb-fynewever/aprilTagOnRaspi"],
  ["LED Controller", { "C++": 84.6, C: 15.4 }, "https://github.com/frc2052/CicadaLEDS"],
  ["FRC 2026 Rebuilt", { Java: 100 }, "https://github.com/frc2052/2026-Rebuilt"],
  ["FRC 2025 Reefscape", { Java: 100 }, "https://github.com/frc2052/2025-Reefscape"],
  ["FRC 2024 Crescendo", { Java: 95.6, Python: 3, "C++": 1.2, C: 0.2 }, "https://github.com/frc2052/2024-Crescendo"],
  ["FRC 2023 Charged Up", { Java: 98.6, "C++": 1.2, C: 0.2 }, "https://github.com/frc2052/2023-ChargedUp"],
];

function Projects() {
  return <div className="projects-section">{projects.map(([projectTitle, languages, link]) =>
    <ProjectTile key={projectTitle} projectTitle={projectTitle} languages={languages} link={link} />)}
  </div>;
}

export default Projects;
